import { render, staticRenderFns } from "./AMLists.vue?vue&type=template&id=7a632456&"
import script from "./AMLists.vue?vue&type=script&lang=js&"
export * from "./AMLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports